module.exports = __webpack_public_path__ + "img/bg5.9c255d3c.png";